import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "ngx-logout",
  templateUrl: "./logout.component.html",
  styleUrls: ["./logout.component.scss"],
})
export class LogoutComponent implements OnInit {
  constructor(private Route: Router) {}

  ngOnInit(): void {
    localStorage.removeItem("access_token");
    this.Route.navigate(["/login"]);
  }
}
